import { render, staticRenderFns } from "./WebShare.vue?vue&type=template&id=631e8974&scoped=true&"
import script from "./WebShare.vue?vue&type=script&lang=js&"
export * from "./WebShare.vue?vue&type=script&lang=js&"
import style0 from "./WebShare.vue?vue&type=style&index=0&id=631e8974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e8974",
  null
  
)

export default component.exports